import _extends from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
import _objectWithoutProperties from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["node"],
  _excluded2 = ["node"],
  _excluded3 = ["node"],
  _excluded4 = ["node"],
  _excluded5 = ["node"],
  _excluded6 = ["node"],
  _excluded7 = ["node"],
  _excluded8 = ["node"],
  _excluded9 = ["node"],
  _excluded0 = ["node"],
  _excluded1 = ["node"],
  _excluded10 = ["node"],
  _excluded11 = ["node"],
  _excluded12 = ["node"],
  _excluded13 = ["node"],
  _excluded14 = ["node"];
import React from "react";
var __jsx = React.createElement;
import Markdown from "react-markdown";
import remarkGfm from "remark-gfm";
function CustomMarkdown(props) {
  return /*#__PURE__*/React.createElement(Markdown, {
    remarkPlugins: [remarkGfm],
    components: {
      ul: function ul(props) {
        var node = props.node,
          rest = _objectWithoutProperties(props, _excluded);
        return /*#__PURE__*/React.createElement("ul", _extends({
          className: "list-disc pl-5 p-3"
        }, rest));
      },
      h2: function h2(props) {
        var node = props.node,
          rest = _objectWithoutProperties(props, _excluded2);
        return /*#__PURE__*/React.createElement("h2", _extends({
          className: "leading-[50px] font-semibold text-lg"
        }, rest));
      },
      h1: function h1(props) {
        var node = props.node,
          rest = _objectWithoutProperties(props, _excluded3);
        return /*#__PURE__*/React.createElement("h1", _extends({
          className: "leading-[70px] font-bold text-xl"
        }, rest));
      },
      p: function p(props) {
        var node = props.node,
          rest = _objectWithoutProperties(props, _excluded4);
        return /*#__PURE__*/React.createElement("p", _extends({
          className: "break-words overflow-wrap-anywhere max-w-full w-fit"
        }, rest));
      },
      pre: function pre(props) {
        var node = props.node,
          rest = _objectWithoutProperties(props, _excluded5);
        return /*#__PURE__*/React.createElement("pre", _extends({
          className: "overflow-x-auto whitespace-pre-wrap break-words max-w-full p-3 rounded-md"
        }, rest));
      },
      code: function code(props) {
        var node = props.node,
          rest = _objectWithoutProperties(props, _excluded6);
        return /*#__PURE__*/React.createElement("code", _extends({
          className: "break-words overflow-wrap-anywhere max-w-full"
        }, rest));
      },
      blockquote: function blockquote(props) {
        var node = props.node,
          rest = _objectWithoutProperties(props, _excluded7);
        return /*#__PURE__*/React.createElement("blockquote", _extends({
          className: "border-l-4 border-gray-300 pl-4 py-2 my-4 break-words overflow-wrap-anywhere max-w-full"
        }, rest));
      },
      table: function table(props) {
        var node = props.node,
          rest = _objectWithoutProperties(props, _excluded8);
        return /*#__PURE__*/React.createElement("div", {
          className: "overflow-x-auto"
        }, /*#__PURE__*/React.createElement("table", _extends({
          className: "min-w-full border-collapse border border-gray-300"
        }, rest)));
      },
      td: function td(props) {
        var node = props.node,
          rest = _objectWithoutProperties(props, _excluded9);
        return /*#__PURE__*/React.createElement("td", _extends({
          className: "border border-gray-300 px-3 py-2 break-words overflow-wrap-anywhere max-w-full"
        }, rest));
      },
      th: function th(props) {
        var node = props.node,
          rest = _objectWithoutProperties(props, _excluded0);
        return /*#__PURE__*/React.createElement("th", _extends({
          className: "border border-gray-300 px-3 py-2 bg-gray-100 font-semibold break-words overflow-wrap-anywhere max-w-full"
        }, rest));
      },
      li: function li(props) {
        var node = props.node,
          rest = _objectWithoutProperties(props, _excluded1);
        return /*#__PURE__*/React.createElement("li", _extends({
          className: "break-words overflow-wrap-anywhere max-w-full"
        }, rest));
      },
      h3: function h3(props) {
        var node = props.node,
          rest = _objectWithoutProperties(props, _excluded10);
        return /*#__PURE__*/React.createElement("h3", _extends({
          className: "leading-[40px] font-semibold text-base break-words overflow-wrap-anywhere max-w-full"
        }, rest));
      },
      h4: function h4(props) {
        var node = props.node,
          rest = _objectWithoutProperties(props, _excluded11);
        return /*#__PURE__*/React.createElement("h4", _extends({
          className: "leading-[35px] font-semibold text-sm break-words overflow-wrap-anywhere max-w-full"
        }, rest));
      },
      h5: function h5(props) {
        var node = props.node,
          rest = _objectWithoutProperties(props, _excluded12);
        return /*#__PURE__*/React.createElement("h5", _extends({
          className: "leading-[30px] font-semibold text-xs break-words overflow-wrap-anywhere max-w-full"
        }, rest));
      },
      h6: function h6(props) {
        var node = props.node,
          rest = _objectWithoutProperties(props, _excluded13);
        return /*#__PURE__*/React.createElement("h6", _extends({
          className: "leading-[25px] font-semibold text-xs break-words overflow-wrap-anywhere max-w-full"
        }, rest));
      },
      ol: function ol(props) {
        var node = props.node,
          rest = _objectWithoutProperties(props, _excluded14);
        return /*#__PURE__*/React.createElement("ol", _extends({
          className: "list-decimal pr-3 p-5 break-words overflow-wrap-anywhere max-w-full"
        }, rest));
      }
    }
  }, props.markdown);
}
export default CustomMarkdown;